import React from 'react';
import { useState } from 'react';
import { useAppContext } from 'components/Context/AppContext';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import ButtonAdd from 'components/Global/ButtonAdd';
import { ReactComponent as HolidayChargeIcon } from 'icons/holiday-charge-filled-icon.svg';
import { PaginationTable, Table, TableWrapper } from 'components/Global';
import LoadingSpinner from 'components/Global/LoadingSpinner';
import { deleteHolidayById, getAllHolidays } from 'features/holiday-charge/actions';
import EmptyState from 'components/Global/EmptyState';
import { resetSelectedHoliday } from 'features/holiday-charge/slice';
import { trackEvent } from 'utils/analytics';
import { setCurrency } from 'utils/functionality';

const HolidayChargeComponent = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const column = [
    { header: 'No.', value: 'no' },
    { header: 'Lokasi', value: 'location' },
    { header: 'Nama Hari Libur', value: 'holiday_name' },
    { header: 'Charge Tambahan', value: 'value' },
  ];

  const { setShowConfirmation, setShowSpinner, showToast } = useAppContext();

  const { isLoading, data } = useSelector((state) => state.holidayCharge);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllHolidays({ page: currentPage, limit: 10 }));
  }, [currentPage]);

  const handleDelete = (e) => {
    const itemId = e.target.parentElement.parentElement.dataset['key'];
    setShowConfirmation({
      message: 'Apakah anda yakin ingin menghapus Item',
      show: true,
      onClick: async () => {
        try {
          setShowSpinner(true);
          trackEvent('holiday_charge_deleted', { holiday_id: itemId, source: 'holiday_charge_list' });
          await dispatch(deleteHolidayById(itemId)).unwrap();
          showToast({ type: 'success', message: 'Berhasil Hapus Item' });
          setCurrentPage(1);
          dispatch(getAllHolidays({ page: 1, limit: 10 }));
        } catch (error) {
          showToast({ type: 'error', message: 'Gagal Hapus Item' });
        } finally {
          setShowSpinner(false);
        }
      },
    });
  };

  const handleEdit = (e) => {
    const dataId = e.target.parentElement.parentElement.dataset['key'];
    dispatch(resetSelectedHoliday());
    navigate(`/holiday-charge/edit?id=${dataId}`);
  };

  const handleAdd = () => {
    dispatch(resetSelectedHoliday());
    navigate('/holiday-charge/add');
  };

  const mappedData = data?.data?.map((item) => ({
    id: item.id,
    holiday_name: item.name,
    location: item.location?.name,
    value:
      item.value_type === 'fixed'
        ? setCurrency(item.charges, item.location?.currency)
        : item.value_type === 'percentage'
        ? `${item.charges} %`
        : '-',
  }));

  return (
    <div className="holiday-charge">
      <ButtonAdd onClick={handleAdd} label="Tambah Holiday Charge" />

      <TableWrapper title="Holiday Charge" icon={<HolidayChargeIcon fill="#009EF7" width="25px" height="25px" />}>
        {isLoading ? (
          <LoadingSpinner />
        ) : data?.data?.length ? (
          <>
            <Table
              column={column}
              data={mappedData}
              actionBtn
              onDel={handleDelete}
              onEdit={handleEdit}
              currentPage={currentPage}
            />
            <PaginationTable
              currentPage={currentPage}
              onPageChange={(newPage) => setCurrentPage(newPage)}
              totalCount={data?.pagination?.total}
            />
          </>
        ) : (
          <EmptyState />
        )}
      </TableWrapper>
    </div>
  );
};

export default HolidayChargeComponent;
